import React, { Fragment, useState } from "react";
import { required, InputField, isNotEmpty } from "modules/4_final_form/mobile";

import { Field } from "react-final-form";

import SelectMarkInstances from "modules/production/strumis/contract/mark_instances/mobile/SelectMarkInstances";
import { OnChange } from "react-final-form-listeners";
import { FieldArray } from "react-final-form-arrays";
import { v4 as uuidv4 } from "uuid";
import { AccordionContent, Block, BlockTitle, Button, List, ListItem } from "framework7-react";

// Renders the parent component for the assembly details tab
const AssemblyDetailsTab = (props) => {
  const { edit } = props;

  if (!edit) {
    return <NewInspectionSelection {...props} />;
  } else {
    return <EditInspectionSelection {...props} />;
  }
};

export default AssemblyDetailsTab;

const NewInspectionSelection = (props) => {
  const { form, project } = props;

  const searchInStrumis = project?.strumis_connected;
  const strumis_contracts = _.map(project?.strumis_contracts_attributes, "value");
  return (
    <Fragment>
      {searchInStrumis && (
        <Fragment>
          <SelectMarkInstances
            name="assemblies"
            label="Select Assemblies"
            closeMenuOnSelect={false}
            multi
            strumis_contracts={strumis_contracts}
            filters={{ production_stage_id: 14 }}
            option_label={(mi) => {
              let label = `${mi?.mark} - Phase ${mi?.phase} - Lot ${mi?.lot} - ${mi?.guid?.substring(0, 4)}`;
              if (mi?.welding_inspections_count) {
                label += ` - ${mi?.welding_inspections_count} Inspection`;
              }
              return label;
            }}
            filterByStageTitle="Showing assemblies at welding stage"
          />
          <hr />
        </Fragment>
      )}
      <Block>
        <BlockTitle>Welding Inspection Assemblies</BlockTitle>
      </Block>
      <FieldArray name="assemblies" validate={isNotEmpty} component={Assemblies} form={form} />
    </Fragment>
  );
};

const EditInspectionSelection = (props) => {
  const { project, values } = props;

  const searchInStrumis = project?.strumis_connected;
  const strumis_contracts = _.map(project?.strumis_contracts_attributes, "value");

  return (
    <Fragment>
      {searchInStrumis && (
        <SelectMarkInstances
          name="assembly.strumis_mark_instance_id"
          label="Select Assembly"
          closeMenuOnSelect={false}
          strumis_contracts={strumis_contracts}
          filters={{ production_stage_id: 14 }}
          backupLabel={values?.assembly?.display_name_full}
          option_label={(mi) => {
            let label = `${mi?.mark} - Phase ${mi?.phase} - Lot ${mi?.lot} - ${mi?.guid?.substring(0, 4)}`;
            if (mi?.welding_inspections_count) {
              label += ` - ${mi?.welding_inspections_count} Inspection`;
            }
            return label;
          }}
        />
      )}
      <List>
        <AssemblyForm slot="list" fieldName="assembly" thisField={values?.assembly} {...props} />
      </List>
    </Fragment>
  );
};

const Assemblies = (props) => {
  const { fields, form } = props;

  return (
    <Fragment>
      <List accordionList>
        {fields.map((name, index) => {
          return (
            <AssemblyRow
              key={index}
              fieldName={name}
              thisField={fields.value[index]}
              fields={fields}
              form={form}
              removeField={() => {
                fields.remove(index);
              }}
              slot="list"
            />
          );
        })}
      </List>
      <Block slot="list">
        <Button
          fill
          className="mt-3"
          onClick={() => {
            fields.push({ defaultOpen: true, value: uuidv4() });
          }}
        >
          Add Manual Assembly
        </Button>
      </Block>
    </Fragment>
  );
};

const AssemblyRow = (props) => {
  const { fieldName, thisField, removeField, fields, form } = props;
  const [itemOpen, setItemOpen] = useState(thisField.defaultOpen ? true : false);

  const toggle = () => setItemOpen(!itemOpen);

  const changeField = (changesObject) => {
    form.change(fieldName, { ...thisField, ...changesObject });
  };

  const title = `${thisField?.mark} - Phase ${thisField?.phase} - Lot ${thisField?.lot}`;

  return (
    <ListItem accordionItem title={title}>
      <AccordionContent>
        <AssemblyForm fieldName={fieldName} thisField={thisField} changeField={changeField} />
      </AccordionContent>
    </ListItem>
  );
};

const AssemblyForm = (props) => {
  const { fieldName, thisField, changeField } = props;
  const readOnly = thisField?.strumis_mark_instance_id ? true : false;
  const label = `${thisField?.mark} - Phase ${thisField?.phase} - Lot ${thisField?.lot}`;

  return (
    <Fragment>
      {readOnly && <Field name={`${fieldName}.guid`} label="GUID" component={InputField} validate={required} placeholder="GUID" disabled />}

      <Field name={`${fieldName}.mark`} label="Mark Name" component={InputField} validate={required} placeholder="Mark Name" disabled={readOnly} />

      {/* <Field name={`${fieldName}.description`} label="Description" component={InputField} placeholder="Description" disabled={readOnly} /> */}
      <Field name={`${fieldName}.phase`} label="Phase" component={InputField} validate={required} placeholder="Phase Name" disabled={readOnly} />
      <Field name={`${fieldName}.lot`} label="Lot" component={InputField} validate={required} placeholder="Lot Name" disabled={readOnly} />
      {/* <Field name={`${fieldName}.paint_finish`} label="Paint Finish" component={InputField} placeholder="Paint Finish" disabled={readOnly} /> */}
      <Field name={`${fieldName}.weld_group`} label="Weld Group" component={InputField} placeholder="Weld Group" disabled={readOnly} />

      <OnChange name={`${fieldName}.mark`}>
        {(value, previous) => {
          if (changeField) changeField({ label: label });
        }}
      </OnChange>
      <OnChange name={`${fieldName}.description`}>
        {(value, previous) => {
          if (changeField) changeField({ label: label });
        }}
      </OnChange>
      <OnChange name={`${fieldName}.phase`}>
        {(value, previous) => {
          if (changeField) changeField({ label: label });
        }}
      </OnChange>
      <OnChange name={`${fieldName}.lot`}>
        {(value, previous) => {
          if (changeField) changeField({ label: label });
        }}
      </OnChange>
    </Fragment>
  );
};
